import {
  ELumaBotFlowType,
  ELumaBotQuestionType,
  ELumaBotTemplateItemRedirectType,
  TMessage,
  TAvailability,
} from 'ui-model';

export { ELumaBotFlowType, ELumaBotQuestionType, ELumaBotTemplateItemRedirectType };

export enum EMessageType {
  Inbound = 'inbound',
  Outbound = 'outbound',
}

// WORKAROUND extending TMessage to fix type enum errors
export interface IMessage extends Omit<TMessage, 'type' | 'createdAt'> {
  type: EMessageType;
  createdAt: string | Date;
  lumabotFlowId: string;
  details: {
    availability: Partial<TAvailability>;
  };
}

export enum EUserContactType {
  Inapp = 'inapp',
  Sms = 'sms',
  Voice = 'voice',
  Email = 'email',
  Fax = 'fax',
  Whatsapp = 'whatsapp',
}

enum EUserContactArchivedReason {
  None = 'none',
  Unreachable = 'unreachable',
  DoNotContact = 'do-not-contact',
}

// WORKAROUND: TRef fields might not be populated
export type TRef<I> = I | string;
export interface IUserContact {
  type?: EUserContactType;
  value?: string;
  active?: boolean;
  archived?: boolean;
  archivedReason?: EUserContactArchivedReason;
  archivedMessage?: TRef<IMessage>;
}
